module.exports = "/static/assets/9ddae4f6c1aeaf0784007203d9d4ac9c.svg";